import React, { useEffect, useMemo, useState } from 'react'
import './resultCard.scss'
import happyFace from '../../../assets/happy-face.svg'
import regularFace from '../../../assets/regular-face.svg'
import angryFace from '../../../assets/angry-face.svg'

interface ResultCardProps {
	title: string;
	description: string;
	score: 'bad' | 'medium' | 'good';
}

const facesStyles = [
	{
		color: "#7ECCC9",
		cursorColor: "#18A8A2",
		image: happyFace
	},
	{
		color: "#ECA785",
		cursorColor: "#E16F2A",
		image: regularFace
	},
	{
		color: "#ED667B",
		cursorColor: "#FC0542",
		image: angryFace
	},
]

const ResultCard = (props: ResultCardProps) => {

	const calculated = useMemo(() => {
		let index;
		let position;
		switch (props.score) {
			case 'bad':
				index = 2;
				position = 16.6;
				break;
			case 'medium':
				index = 1;
				position = 49.9;
				break;
			case 'good':
				index = 0;
				position = 83.2;
				break;
		}
		return ({
			color: facesStyles[index].color,
			img: facesStyles[index].image,
			cursorColor: facesStyles[index].cursorColor,
			position: position,
		})
	}, [props.score])

	return (
		<div className='result-card'>
			<section className="result-card__indicator">
				<div
					className='result-card__indicator__background'
					style={{ backgroundColor: calculated.color }}
				>
					<img
						src={calculated.img}
						className="result-card__indicator__background__image"
						alt="Imagen resultado"
					/>
				</div>
				<div className="result-card__indicator__stoplight">
					<div className='result-card__indicator__stoplight__container'>
						<div className="result-card__indicator__stoplight__item result-card__indicator__stoplight__item--red"></div>
						<div className="result-card__indicator__stoplight__item result-card__indicator__stoplight__item--yellow"></div>
						<div className="result-card__indicator__stoplight__item result-card__indicator__stoplight__item--green"></div>
						<div
							className="result-card__indicator__stoplight__container__cursor"
							style={{ backgroundColor: calculated.cursorColor, left:`calc(${calculated.position}% - 8.76px)`}}
						></div>

					</div>
				</div>
			</section>
			<section className='result-card__info'>
				<h3 className='result-card__info__title'>{props.title}</h3>
				<p className='result-card__info__description'>{props.description}</p>
			</section>
		</div>
	)
}

export default ResultCard;